'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //region import React

//endregion

//region import components


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _taReactShareButtons = require('ta-react-share-buttons');

var _taReactShareButtons2 = _interopRequireDefault(_taReactShareButtons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//endregion

//region import CSS
// Semantic UI
require('ta-semantic-ui/semantic/dist/components/reset.css');
// require('ta-semantic-ui/semantic/dist/components/site.css');
require('ta-semantic-ui/semantic/dist/components/grid.css');
require('ta-semantic-ui/semantic/dist/components/container.css');
require('ta-semantic-ui/semantic/dist/components/image.css');

// Specific CSS
require('./../style/Masthead.css');
//endregion

/**
 * Renders the masthead component.
 * @param props
 * @returns {XML}
 * @constructor
 */
function Masthead(props) {

  // Prepare constants for the inverted version
  var invertedClass = props.inverted ? 'inverted' : '';
  var invertedImgSrcName = props.inverted ? '-inverted' : '';

  return _react2.default.createElement(
    'div',
    { className: 'ta-masthead masthead-component ' + invertedClass },
    _react2.default.createElement(
      'div',
      { className: 'ui container ' },
      _react2.default.createElement(
        'div',
        { className: 'ui two column middle aligned grid' },
        _react2.default.createElement(
          'div',
          { className: 'column ta-logo' },
          _react2.default.createElement(
            'a',
            { href: props.homepage },
            ' ',
            _react2.default.createElement('img', {
              src: '//interaktiv.tagesanzeiger.ch/static/logos/' + props.mediaName + invertedImgSrcName + '.svg',
              alt: props.fullMediaName,
              className: 'ui middle aligned logo image' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'right aligned column' },
          _react2.default.createElement(_taReactShareButtons2.default, _extends({}, props, { displayType: 'horizontal icons' }))
        )
      )
    )
  );
}

Masthead.propTypes = {
  /**
   * The media name whose logo should be shown.
   */
  mediaName: _react2.default.PropTypes.string,
  /**
   * The outwards facing media name.
   */
  fullMediaName: _react2.default.PropTypes.string,
  /**
   * The home page of the medium to link to.
   */
  homepage: _react2.default.PropTypes.string,
  /**
   * The URL to share. Will be overriden by URLs in the {@link communities}
   * array.
   * @type {string}
   */
  url: _react2.default.PropTypes.string,
  /**
   * Whether the masthead should be displayed inverted.
   */
  inverted: _react2.default.PropTypes.bool,
  /**
   * Hashtags as an array of strings. Facebook will only use the first one.
   * @type {Array.string}
   */
  hashtags: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string),
  /**
   * Community objects, as provided by the External Services API service by
   * Newsnet.
   * @type {Array.Object}
   */
  communities: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
    type: _react2.default.PropTypes.string.isRequired,
    url: _react2.default.PropTypes.string,
    description: _react2.default.PropTypes.string,
    count: _react2.default.PropTypes.number
  }))
};

Masthead.defaultProps = {
  inverted: false,
  mediaName: 'tagesanzeiger',
  homepage: '//www.tagesanzeiger.ch',
  fullMediaName: 'Tages-Anzeiger'
};

exports.default = Masthead;


//////////////////
// WEBPACK FOOTER
// ./~/ta-react-masthead/dist/index.js
// module id = 359
// module chunks = 0